module.exports = __webpack_public_path__ + "./favicons/apple-icon-120x120.png";